import { render, staticRenderFns } from "./IsAbgeschlossenWarning.vue?vue&type=template&id=819b4b94"
import script from "./IsAbgeschlossenWarning.vue?vue&type=script&lang=js"
export * from "./IsAbgeschlossenWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports